export default {
  UPLOADER: 0,
  LEGAL: 1,
  TRANSFER: 2,
  CANCEL: 3,
  FINISH: 4,
};
